import { startApp } from "./lib/app";

startApp();
